import EventEmitter from "events";
import store from "@/stores/store";
import { ModuleContext } from "@/stores/moduleConst";
import commonFn from "@/commons/commonFunction";
import accountApi from "@/apis/other/accountAPI";
class AuthService extends EventEmitter {
  /**
   * Kiểm tra xem còn session đăng nhập ko
   */
  isAuthenticated() {
    const context = store.state[ModuleContext];
    let a = store;
    if (context.Token) {
      let expired = context.TokenExpired;
      if (expired && new Date(expired) > new Date()) {
        return true;
      }
    }
    return false;
  }

  /**
   * xử lý login 
   * hàm này sẽ redirect qua trang login
   */
  login(param) {
    commonFn.mask();
    location.href = "/login";
  }


  /**
   * xử lý login qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để login
   */
  async doLogin(param) {
    await accountApi.doLogin(param)
  }
}

export default new AuthService();
